import { useState, FormEvent } from "react";

export default function ContactSection() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as Record<string, string>);
    try {
      await fetch("https://readdy.ai/api/form/d7f75dnimhg6tri2v670", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="w-full bg-[#111111] py-24 px-6 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-16">
          {/* Left */}
          <div className="w-full lg:w-1/2">
            <p className="text-red-500 uppercase tracking-[0.3em] text-xs font-bold mb-3">Get in Touch</p>
            <h2 className="text-4xl md:text-5xl font-black text-white uppercase mb-6" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
              Contact Us
            </h2>
            <p className="text-gray-500 text-sm leading-relaxed mb-10">
              Have a question, want to ride with us, or just want to say hello? Send us a message and the brotherhood will get back to you.
            </p>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-red-900/30 border border-red-800/30 flex-shrink-0">
                  <i className="ri-map-pin-2-line text-red-500 text-xl"></i>
                </div>
                <div>
                  <p className="text-white text-sm font-semibold uppercase tracking-wider">Headquarters</p>
                  <p className="text-gray-500 text-sm mt-1">Rochester New York&nbsp;</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-red-900/30 border border-red-800/30 flex-shrink-0">
                  <i className="ri-phone-line text-red-500 text-xl"></i>
                </div>
                <div>
                  <p className="text-white text-sm font-semibold uppercase tracking-wider">Phone</p>
                  <p className="text-gray-500 text-sm mt-1">(585) 406-5110</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-red-900/30 border border-red-800/30 flex-shrink-0">
                  <i className="ri-mail-line text-red-500 text-xl"></i>
                </div>
                <div>
                  <p className="text-white text-sm font-semibold uppercase tracking-wider">Email</p>
                  <p className="text-gray-500 text-sm mt-1">respectmotorcycleclub@gmail.com</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-red-900/30 border border-red-800/30 flex-shrink-0">
                  <i className="ri-time-line text-red-500 text-xl"></i>
                </div>
                <div>
                  <p className="text-white text-sm font-semibold uppercase tracking-wider">Chapter Meetings</p>
                  <p className="text-gray-500 text-sm mt-1">Monthly</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Form */}
          <div className="w-full lg:w-1/2">
            {submitted ? (
              <div className="h-full flex flex-col items-center justify-center py-20 border border-red-700 bg-[#1a0a0a]">
                <div className="w-16 h-16 flex items-center justify-center mb-4">
                  <i className="ri-send-plane-line text-red-500 text-5xl"></i>
                </div>
                <p className="text-white font-black text-2xl uppercase" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>Message Sent!</p>
                <p className="text-gray-400 text-sm mt-2">We&apos;ll be in touch soon.</p>
              </div>
            ) : (
              <form data-readdy-form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-gray-400 text-xs uppercase tracking-widest mb-2">Name</label>
                    <input name="name" required type="text" className="w-full bg-[#1a1a1a] border border-[#2a2a2a] text-white px-4 py-3 text-sm focus:outline-none focus:border-red-600 transition-colors" placeholder="Your name" />
                  </div>
                  <div>
                    <label className="block text-gray-400 text-xs uppercase tracking-widest mb-2">Email</label>
                    <input name="email" required type="email" className="w-full bg-[#1a1a1a] border border-[#2a2a2a] text-white px-4 py-3 text-sm focus:outline-none focus:border-red-600 transition-colors" placeholder="your@email.com" />
                  </div>
                </div>
                <div>
                  <label className="block text-gray-400 text-xs uppercase tracking-widest mb-2">Subject</label>
                  <input name="subject" required type="text" className="w-full bg-[#1a1a1a] border border-[#2a2a2a] text-white px-4 py-3 text-sm focus:outline-none focus:border-red-600 transition-colors" placeholder="What&apos;s this about?" />
                </div>
                <div>
                  <label className="block text-gray-400 text-xs uppercase tracking-widest mb-2">Message</label>
                  <textarea
                    name="message"
                    required
                    rows={5}
                    maxLength={500}
                    className="w-full bg-[#1a1a1a] border border-[#2a2a2a] text-white px-4 py-3 text-sm focus:outline-none focus:border-red-600 transition-colors resize-none"
                    placeholder="Your message..."
                  ></textarea>
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-red-700 hover:bg-red-600 text-white uppercase font-bold tracking-widest py-4 text-sm transition-all duration-200 cursor-pointer disabled:opacity-50 whitespace-nowrap"
                >
                  {loading ? "Sending..." : "Send Message"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
